<script setup>
import { storeToRefs } from 'pinia'
import { useAdminCenterStore } from '../../stores/AdminCenterStore'
import BcsCard from '../common/BcsCard.vue'
import BcsStatPill from '../common/BcsStatPill.vue'

const adminCenterStore = useAdminCenterStore()
const {
  isLoading,
  totalEmployers,
  unassignedEmployers,
  totalAccountOwners,
  invitesSent,
  pendingInvites
} = storeToRefs(adminCenterStore)
</script>

<template>
  <div class="row mt-4 mb-4 pb-1.5">
    <!-- Agency Stats Card -->
    <div class="col-12 col-lg-7 mb-3 mb-lg-0">
      <BcsCard title="Agency Stats">
        <div v-if="isLoading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else class="row text-center py-1 px-2">
          <div class="col-sm-4">
            <BcsStatPill
              :value="totalEmployers"
              label="Total Employers"
              description="Total employer groups assigned to this agency."
            />
          </div>
          <div class="col-sm-4">
            <BcsStatPill
              :value="totalAccountOwners"
              label="Total Account Owners"
              description="Account team members with access to BCS software."
            />
          </div>
          <div class="col-sm-4">
            <BcsStatPill
              :value="unassignedEmployers"
              label="Unassigned Employers"
              description="Employers without an assigned account owner."
            />
          </div>
        </div>
      </BcsCard>
    </div>

    <!-- Account Invites Card -->
    <div class="col-12 col-lg-5">
      <BcsCard title="Account Invites">
        <div v-if="isLoading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else class="row text-center py-1 px-2">
          <div class="col-sm-6">
            <BcsStatPill
              :value="invitesSent"
              label="Invites Sent"
              description="Total number of pending and accepted invites sent."
            />
          </div>
          <div class="col-sm-6">
            <BcsStatPill
              :value="pendingInvites"
              label="Pending Invites"
              description="Team members who have received invites but not yet accepted."
            />
          </div>
        </div>
      </BcsCard>
    </div>
  </div>
</template>
